import React from "react";
import "./spinner.css";
import Lottie from 'react-lottie';
import loading from '../../lotties/loading.json';
export default function LoadingSpinner() {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    speed: 1,
    animationData: loading,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };
  return (
    <div className="loading-container">
      <Lottie
        options={ defaultOptions }
      />
    </div>
  );
}